import { render, staticRenderFns } from "./SingleLineTextView.vue?vue&type=template&id=2b37cad6&scoped=true"
import script from "./SingleLineTextView.vue?vue&type=script&lang=js"
export * from "./SingleLineTextView.vue?vue&type=script&lang=js"
import style1 from "./SingleLineTextView.vue?vue&type=style&index=1&id=2b37cad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b37cad6",
  null
  
)

export default component.exports